/* @flow */

import { compose } from 'ramda';
import * as React from 'react';
import { createUseStyles } from 'react-jss';

import styles from './OnboardingIntroBackground.style';

import defaultOnboardingPicture from 'src/shared/app/onboarding/assets/onboarding_a.jpg';
import defaultVbdOnboardingPicture from 'src/shared/app/onboarding/assets/vbd_onboarding.png';
import { getStaticAsset } from 'src/shared/app/base/util/assetUtils';

type Props = {
  backgroundImage: Object,
  isVideoCallEnabled: Boolean,
};

const useStyles = createUseStyles(styles);

const OnboardingIntroBackgroundDumb = ({
  backgroundImage,
  isVideoCallEnabled,
}: Props): React.Node => {
  const classes: Object = useStyles();

  const defaultImage = isVideoCallEnabled
    ? defaultVbdOnboardingPicture
    : defaultOnboardingPicture;

  const rootStyles = {
    // FIXME: don't hardcode resolution
    backgroundImage: backgroundImage['1280x720']
      ? `url(${backgroundImage['1280x720']})`
      : `url(${getStaticAsset(defaultImage)})`,
  };

  return <div className={classes.root} style={rootStyles} />;
};

export default compose(React.memo)(OnboardingIntroBackgroundDumb);
